export default function () {
  return {
    alerts: [],
    notifications: [],
    validation: [],
    supress: false
  }
}
